import { useCallback, useEffect } from "react";

import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import {
  Box,
  Typography,
  Divider,
  Card,
  CardContent,
  Stack,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
} from "@mui/material";

import TicketsMessageNotFound from "../TicketsMessageNotFound";

function TicketsMobile({
  filteredTickets,
  handleOpenModal,
  getStatusChip,
  orderBy,
  statusFilter,
  setStatusFilter,
  setOrderBy,
  paginatedTickets,
  page,
  rowsPerPage,
  setPage,
}) {
  const scrollToTop = useCallback(() => {
    const container = document.getElementById("tickets-mobile-container");
    if (container) {
      container.scrollIntoView({ behavior: "smooth" });
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, []);

  useEffect(() => {
    scrollToTop();
  }, [scrollToTop, paginatedTickets]);

  return (
    <Box id="tickets-mobile-container">
      <Typography variant="h5" fontWeight={600} mb={2} textAlign="center">
        Ordens de Serviço
      </Typography>

      <Divider sx={{ mb: 2 }} />

      <Box marginBottom={2} display="flex" justifyContent="flex-end" gap={2}>
        <FormControl variant="standard">
          <InputLabel>Ordenar por</InputLabel>
          <Select
            label="Ordenar por"
            sx={{ minWidth: 110 }}
            value={orderBy}
            onChange={(e) => setOrderBy(e.target.value)}
          >
            <MenuItem value="recent">Mais recente</MenuItem>
            <MenuItem value="oldest">Mais antiga</MenuItem>
          </Select>
        </FormControl>

        <FormControl variant="standard">
          <InputLabel>Status</InputLabel>
          <Select
            label="Status"
            sx={{ minWidth: 70 }}
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
          >
            <MenuItem value="Todos">Todos</MenuItem>
            <MenuItem value="Aberta">Aberta</MenuItem>
            <MenuItem value="Pendente">Pendente</MenuItem>
            <MenuItem value="Fechada">Fechada</MenuItem>
            <MenuItem value="Cancelada">Cancelada</MenuItem>
          </Select>
        </FormControl>
      </Box>

      {filteredTickets.length === 0 ? (
        <Box mt={6}>
          <TicketsMessageNotFound />
        </Box>
      ) : (
        <Stack spacing={2} width="100%" alignItems="center">
          {paginatedTickets.map((ticket) => {
            const { NumeroOS, Modelo, Abertura, SituacaoDaOS, TipoDeManutencao } = ticket;

            return (
              <Card
                key={NumeroOS}
                elevation={2}
                sx={{ borderRadius: 3, width: "100%", cursor: "pointer" }}
                onClick={() => handleOpenModal(ticket)}
              >
                <CardContent>
                  <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                    <Box flex={1} display="flex" flexDirection="column">
                      <Typography variant="subtitle1" fontWeight={600}>
                        OS # {NumeroOS}
                      </Typography>
                      <Typography variant="subtitle1" fontWeight={600}>
                        {Modelo}
                      </Typography>
                    </Box>
                    <Box>
                      <ArrowForwardIosIcon />
                    </Box>
                  </Box>
                  <Divider sx={{ mb: 1 }} />
                  <Typography variant="body2" color="text.secondary" mb={0.5}>
                    <strong>Tipo de Manutenção:</strong> {TipoDeManutencao}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" mb={0.5}>
                    <strong>Data de abertura:</strong> {Abertura}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" mb={0.5}>
                    <strong>Status:</strong> {getStatusChip(SituacaoDaOS)}
                  </Typography>
                </CardContent>
              </Card>
            );
          })}

          <Box display="flex" justifyContent="space-between" width="100%" alignItems={"center"}>
            <Button
              disabled={page === 0}
              onClick={() => setPage(page - 1)}
              startIcon={<ArrowForwardIosIcon sx={{ transform: "rotate(180deg)" }} />}
            >
              Anterior
            </Button>

            <Typography>
              {page + 1} de {Math.ceil(filteredTickets.length / rowsPerPage)}
            </Typography>
            <Button
              disabled={(page + 1) * rowsPerPage >= filteredTickets.length}
              onClick={() => setPage(page + 1)}
              endIcon={<ArrowForwardIosIcon />}
            >
              Próxima
            </Button>
          </Box>
        </Stack>
      )}
    </Box>
  );
}

export default TicketsMobile;
